import React, { useState } from "react";
import "./style.css";

export default function ProductCard({ name, uid, slug, image, sku, selected, onClickFn, sale_price, regular_price, onClickFn2, fob_price, qty, stock, showFobPrice,showLandedCost,landedCost }) {
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <div className={selected ? "product_card_1 selected" : "product_card_1"}>
            <div className="image_section">
                {!imageLoaded && <div className="image_shimmer" />}
                <img
                    src={image}
                    alt={name}
                    style={{ display: imageLoaded ? "block" : "none" }}
                    onLoad={() => setImageLoaded(true)}
                />
                <div className="buttons_set_1">
                    <button onClick={onClickFn2} >Quick View</button>
                    <button onClick={onClickFn} className={selected ? "selection_btn selected" : "selection_btn"}>
                        {selected ? "Unselect" : "Select"}
                    </button>
                </div>
            </div>
            <p>SKU : {sku}</p>
            <h3>{name}</h3>

            {sale_price ? (
                <>
                    <span className="price">${sale_price}</span>
                    {regular_price && (
                        <span className="old_price" style={{ textDecoration: 'line-through', marginLeft: '5px' }}>
                            ${regular_price}
                        </span>
                    )}
                </>
            ) : (
                <span className="price">${regular_price}</span>
            )}

            {/* {(showFobPrice && fob_price && !showLandedCost) && <div className="fob_price_here">
                FOB : ${fob_price}
            </div>} */}

            <div className="other_info_Section_2">
               {(showLandedCost && landedCost) && <div className="lanced_price_here_2">
                    LC : ${landedCost}
                </div>}
                {(showFobPrice && fob_price ) && <div className="fob_price_here_2">
                    FOB : ${fob_price}
                </div>}
            </div>



            <div className="other_info_Section">
                <div className="section_ois">
                    {qty && `QTY : ${qty}`}
                </div>
                <div className="section_ois" style={{ textAlign: "end" }}>
                    {stock && (
                        <span
                            className={
                                stock.toLowerCase() === "instock"
                                    ? "stock-label in-stock"
                                    : stock.toLowerCase() === "outstock" || stock.toLowerCase() === "outofstock"
                                        ? "stock-label out-stock"
                                        : "stock-label"
                            }
                        >
                            {stock.toLowerCase() === "instock"
                                ? "In Stock"
                                : stock.toLowerCase() === "outstock" || stock.toLowerCase() === "outofstock"
                                    ? "Out Stock"
                                    : stock}
                        </span>
                    )}
                </div>

            </div>



        </div>
    );
}
